/**
 * Creator/advisor earn-oriented copy for the Create New Link flow.
 * Extracted so traveler-facing reuse can swap non-earn strings without forking UI.
 */
export const CREATE_LINK_COPY = {
  step1Title: 'Link, Share, Earn.',
  step1Body:
    'Pick a place or content to share. When someone books through your link, you earn.',
  step2Title: 'Recommend this place',
  step2Body: 'Add an optional note, then generate your share link.',
  notesPlaceholder: 'Why do you recommend this place?',
  generateLink: 'Generate Link',
  step3Title: 'Link Created!',
  step3Body: 'Your recommendation is now live on your storefront.',
  copyLink: 'Copy Link',
  done: 'Done',
  liveBadge: 'LIVE',
  popularHeading: 'Popular',
  searchPlaceholder: 'Search any place…',
  exploreTab: 'Explore',
  postsTab: 'Posts',
  recsTab: 'Recs',
  placesTab: 'Places',
  profileTab: 'Profile',
} as const;
